import React from 'react';
import './Portfolio.css';
import QC from '../../assets/QuizChampSS.png';
import EC from '../../assets/ec-portfolio-img.png';
import OWSLAB from '../../assets/oslab-portfolio-img.png';

const Portfolio = ({isDark}) => {
    return (
        <section id='portfolio' className={isDark === true ? 'dk-section' : 'lt-section'}>
            <div className={isDark === true ? 'dk-section__head' : 'lt-section__head'}>
                <h2>My Recent Work</h2>
                <h5><strong>My Portfolio</strong></h5>
            </div>

            <div className="container portfolio__container">
                <article className={isDark === true ? 'dk-portfolio__item' : 'lt-portfolio__item'}>
                    <div className="portfolio__item-image">
                        <img src={QC} alt='entertainment-center-image' />
                    </div>
                    <h3>Quiz Champ</h3>
                    <div className="portfolio__item-cta">
                        <a href='https://quiz-champ.onrender.com' rel='noreferrer' target='_blank' className={isDark === true ? 'dk-btn dk-btn-primary' : 'lt-btn lt-btn-primary'}>
                            Deployed Demo
                        </a>
                        <a href='https://github.com/JacobHocker/quiz-champ-fe' rel='noreferrer' target='_blank' className={isDark === true ? 'dk-btn dk-btn-primary' : 'lt-btn lt-btn-primary'}>
                            Front-End Repo
                        </a>
                        <a href='https://github.com/JacobHocker/quiz-champ-be' rel='noreferrer' target='_blank' className={isDark === true ? 'dk-btn dk-btn-primary' : 'lt-btn lt-btn-primary'}>
                            Back-End Repo
                        </a>
                    </div>
                </article>
                <article className={isDark === true ? 'dk-portfolio__item' : 'lt-portfolio__item'}>
                    <div className="portfolio__item-image">
                        <img src={OWSLAB} alt='entertainment-center-image' />
                    </div>
                    <h3>OverStat Lab</h3>
                    <div className="portfolio__item-cta">
                        <a href='https://github.com/JacobHocker/overwatch-stat-lab' rel='noreferrer' target='_blank' className={isDark === true ? 'dk-btn dk-btn-primary' : 'lt-btn lt-btn-primary'}>
                            GitHub
                        </a>
                        <a href='https://overstat-lab.herokuapp.com/' rel='noreferrer' target='_blank' className={isDark === true ? 'dk-btn dk-btn-primary' : 'lt-btn lt-btn-primary'}>
                            Live Demo
                        </a>
                        <a href='https://www.youtube.com/watch?v=Z3AFrsbJnLc' rel='noreferrer' target='_blank' className={isDark === true ? 'dk-btn dk-btn-primary' : 'lt-btn lt-btn-primary'}>
                            Watch Video
                        </a>
                    </div>
                </article>
            </div>
        </section>
    )
}

export default Portfolio;